import React from 'react';
import { PolicyAccordions } from '../components/sections/PolicyAccordions';
import { FadeIn } from '../components/ui/FadeIn';

export const PoliciesPage = () => {
  return (
    <div className="pt-24 md:pt-32 bg-ivory min-h-screen">
      <section className="py-20 bg-charcoal relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/pinstriped-suit.png')]" />
        </div>
        <div className="container mx-auto px-6 md:px-14 text-center relative z-10">
          <FadeIn>
            <h1 className="font-serif text-4xl md:text-7xl text-white mb-4 italic">Terms</h1>
            <p className="text-gold/60 tracking-[0.3em] uppercase text-[10px] font-medium">Maison De Charm Guidelines</p>
            <div className="w-16 h-px bg-gold/30 mx-auto mt-8" />
          </FadeIn>
        </div>
      </section>
      <PolicyAccordions />
    </div>
  );
};